export const MENU_ICON_STYLE = {
  mr: 0.5,
  color: 'black'
};

export const MENU_ITEM_STYLE = { pl: 1.5, pr: 4, py: 1.5 };
